/**
 * DeliveryRequest
 * @author ftgibran
 */
import {
    ID,
    IResource,
    Model,
    ResponseFill,
    HttpIgnore,
    ValidationCNPJ,
    ValidationRequired, ObjectCollection, Collection,
} from 'simpli-web-sdk'
import moment from 'moment'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {DeliveryEvent} from '@/enums/DeliveryEvent'
import {DeliveryAudit} from '@/enums/DeliveryAudit'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import {DeliveryDriverStatus} from '@/enums/DeliveryDriverStatus'
import Motorista from '@/model/resource/Motorista'
import {ItrackCollection} from '@/helpers'
import * as Helper from '@/helpers'
import {UF} from '@/enums/UF'
import {Region} from '@/enums/Region'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'

@HttpIgnore()
export default class DeliveryChecklistRequest extends Model {
    readonly $name: string = 'DeliveryChecklistRequest'

    idFilial = Helper.getIdFilial()

    @ResponseFill('start')
    startDate: string | null = null

    endDate: string | null = null

    @ResponseFill()
    get end() {
        // we should send the next day to the server, the prop endDate is used only to control what the user input
        return !this.endDate ? this.endDate : moment(this.endDate).add(1, 'day').format()
    }

    set end(val) {
        if (val) {
            // in the way back we need to subtract, so the params in the route dont mess up
            this.endDate = moment(val).subtract(1, 'day').format()
        }
    }

    @ResponseFill('dateBy')
    dateBy: string | null = null

    @ResponseFill('idMotoristaPk')
    idMotorista: ID | null = null

    @ResponseFill('comMotorista')
    driverStatus: DeliveryDriverStatus | null = null

    @ResponseFill('cte')
    cte: string | null = null

    @ResponseFill('placaVeiculo')
    placaVeiculo: string | null = null

    @ResponseFill()
    cidade: string | null = null

    @ResponseFill('cnpjEmbarcadorTransportador')
    @ValidationCNPJ()
    documentResponsavel: string | null = null

    @ResponseFill('cnpj')
    @ValidationCNPJ()
    documentDestinatario: string | null = null

    @ResponseFill('nroFiscal')
    docs: string | null = null

    @ResponseFill()
    @ValidationRequired()
    uf: UF | null = null

    @ResponseFill()
    @ValidationRequired()
    region: Region | null = null

    @ResponseFill('manifesto')
    manifesto: string | null = null

    allRegion = ItrackCollection.allRegion.prependNull('app.all')
    allStatus = ItrackCollection.allStatus.prependNull('app.all')
    allDocs = new ObjectCollection()

    get docsResource() {
        const str = String(this.docs || '')
        const docs = str.split(',')
        return this.allDocs.getMany(docs)
    }
    set docsResource(val: IResource[]) {
        this.docs = val.map((item: IResource) => item.$id).join(',')
    }

    get regionResource() {
        return this.allRegion.get(this.region)
    }
    set regionResource(val: IResource | null) {
        this.region = val && val.$id as Region || null
    }

    get ufResource() {
        return this.ufCollection.get(this.uf)
    }
    set ufResource(val: IResource | null) {
        this.uf = val && val.$id as UF || null
    }

    get ufCollection() {
        return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
    }

    cleanDocs() {
        this.docs = ''
    }

    cleanCtes() {
        this.cte = ''
    }

    populateAllDocs(val: IResource[]) {
        this.allDocs = new ObjectCollection(val)
    }
}
